// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2slJs","errorLogs":"styles_errorLogs__3OCe2"};